module.exports = __webpack_public_path__ + "img/jewelery.2eddd1b8.jpg";